<template>
    <div class="tw-min-h-screen tw-flex tw-items-center tw-justify-center">
        <div class="tw-flex tw-flex-col tw-items-center tw-text-center tw-p-4">
            <ProgressLoader v-if="isLoading" />
            <div v-else>
                <img
                    :src="imageSrc"
                    :alt="`accept invitation ${status}`"
                    class="tw-max-w-[400px] tw-mb-4"
                />
                <p class="tw-mb-4 tw-text-xl tw-font-semibold">
                    {{ $t(`message.acceptInvitation.${status}.title`) }}
                </p>
                <p class="tw-mb-3s">
                    {{
                        $t(`message.acceptInvitation.${status}.content`, {
                            mainAccountName,
                        })
                    }}
                </p>
                <p class="tw-pb-16">
                    {{ $t(`message.acceptInvitation.${status}.content2`) }}
                </p>
            </div>
        </div>
    </div>
</template>
<script setup>
import { onMounted, ref, computed } from 'vue'
import { acceptSubAccountInvitation } from '@/modules/subAccounts/api/subAccountsApi'
import successImage from '@/assets/invitation_success.png'
import errorImage from '@/assets/invitation_error.png'
import ProgressLoader from '@/components/shared/ProgressLoader.vue'

const props = defineProps({
    token: {
        type: String,
        required: true,
    },
})

const mainAccountName = ref('')
const status = ref('invalid') // success | accepted | invalid
const isLoading = ref(false)

const acceptInvitation = async () => {
    try {
        isLoading.value = true
        const { type, data } = await acceptSubAccountInvitation(props.token)
        if (type) {
            status.value = type
            if (type === 'success' && data?.mainAccount) {
                mainAccountName.value = data.mainAccount.fullName || ''
            }
        }
    } catch (_) {
        status.value = 'invalid'
    } finally {
        isLoading.value = false
    }
}

onMounted(() => {
    acceptInvitation()
})

const imageSrc = computed(() => {
    if (status.value === 'success' || status.value === 'accepted') {
        return successImage
    }
    return errorImage
})
</script>
